import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  CollectionNoticeModel,
  CollectionResponse,
  SingleItemResponse,
  StudentPaymentPlaceModel,
} from '@core/models';
import { environment } from '@env/environment';
import { map, Observable } from 'rxjs';
import { Api } from '../api.state';
import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root',
})
export class StudentPaymentPlaceService extends Api<StudentPaymentPlaceModel> {
  override endpoint: string;

  constructor(
    protected override readonly apiService: ApiService<StudentPaymentPlaceModel>,
    private http: HttpClient
  ) {
    super(apiService);
    this.endpoint = `${environment.apiUrl}/v1/admin/students/pending-review`;
  }

  public getCollectionNoticesByStudent(
    studentId: string
  ): Observable<CollectionNoticeModel[]> {
    const endpoint = `${environment.apiUrl}/v1/admin/students/${studentId}/collection-notices-in-ri`;
    return this.http
      .get<CollectionResponse<CollectionNoticeModel>>(endpoint)
      .pipe(
        map((result) => {
          return result.data.items;
        })
      );
  }

  public approveOrRejectNotice(
    status: string,
    studenCycleId: string,
    studentId: string,
    collectionNoticeId?: string,
    reason?: string
  ): Observable<CollectionNoticeModel | null> {
    const endpoint = `${environment.apiUrl}/v1/admin/students/${studentId}/student-school-cycle/${studenCycleId}/approve-or-reject`;
    return this.http
      .patch<SingleItemResponse<CollectionNoticeModel>>(endpoint, {
        status,
        ...(collectionNoticeId
          ? { collection_notice_id: collectionNoticeId }
          : {}),
        ...(reason ? { reason } : {}),
      })
      .pipe(
        map((result) => {
          return result.data;
        })
      );
  }
}
